import { Grid, Link, Typography } from 'apollo-react';
import { Info } from 'apollo-react-icons';
import React from 'react';

import { FDA_PRODUCT_CODE_DOWNLOAD_URL } from '../../constants/MasterSetupConstants';
import { useTranslation } from '../../custom-hooks/useTranslation';

const SubTitle = () => {
  const translateString = useTranslation();

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item>
        <Info color="primary" aria-hidden="true" />
      </Grid>
      <Grid item>
        <Typography variant="title3" gutterBottom component="p">
          {translateString('Product Codes can be downloaded from the')}
          &nbsp;
          <Link
            size="large"
            variant="subtitle"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download product codes from the FDA website (opens in a new tab)"
            href={FDA_PRODUCT_CODE_DOWNLOAD_URL}
          >
            {translateString('FDA')}
          </Link>
          &nbsp;
          {translateString(
            'website here and imported using the "Import Product Codes" menu option.'
          )}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SubTitle;
